<template>
  <TemplateView>
    <div class="container">
      <div class="wrap">
        <div v-show="!loadingPage && employeeReports" class="employee" key="box">
          <div class="employee__left" v-if="employeeReports && employeeReports.employee">
            <router-link
              :to="{
                name: 'PersonalAreaEmployee',
                params: { userId: employeeReports.employee.user.id },
              }"
              class="employee__avatar"
            >
              <div class="employee__avatar__header">
                <EmployeesPhoto
                  v-if="employeeReports && employeeReports.employee"
                  :size="98"
                  :img="employeeReports.employee.user.photo"
                  :textFirst="employeeReports.employee.user.first_name"
                  :textSecond="employeeReports.employee.user.last_name"
                />
                <div>
                  <h3
                    class="f20 fw500 pt-5 pt-md-0 mb-2"
                    v-if="employeeReports && employeeReports.employee"
                  >
                    {{
                      employeeReports.employee.user.first_name +
                      ' ' +
                      employeeReports.employee.user.last_name
                    }}
                  </h3>
                  <div class="f14">
                    {{ employeeReports.employee.user.email }}
                  </div>
                </div>
              </div>
              <div class="employee__avatar__text"></div>
            </router-link>
            <div class="employee__calendar">
              <div class="employee__calendar__text f18">
                {{
                  localStorage.translations.pages.statistic_employee.text[
                    'vyberite-datu-ili-period'
                  ]
                }}
              </div>
              <div class="employee__calendar__box">
                <v-date-picker
                  v-model="calendarDateSelect"
                  ref="datePicker"
                  width="311"
                  :locale="$cookies.get('languageSelect').key"
                  no-title
                  range
                  :max="new Date().toISOString().slice(0, 10)"
                  :color="checkSelectedDate ? '#277FAF' : '#6f6f6f'"
                  first-day-of-week="1"
                  :events="functionEvents"
                  :allowed-dates="allowedDates"
                  :show-current="$route.query.start"
                  class="temp"
                ></v-date-picker>
                <BaseButton
                  v-show="checkSelectedDate"
                  :disabled="!checkSelectedDate || !calendarDateSelect[0]"
                  @click="onUpdateData({ calendar: true })"
                  :text="localStorage.translations.pages.common.buttons['primenit']"
                  height="40"
                  default_icon="button-confirm"
                />
                <StatisticEmployeeReportModal
                  :buttonShow="
                    $userCheckAccess({
                      abilities: 'edit_work_days',
                    }) && !checkSelectedDate
                  "
                  :buttonText="localStorage.translations.pages.common.buttons['dobavit']"
                  :buttonDisabled="!checkingAvailableDate.find((i) => i === calendarDateSelect[0])"
                  ref="reportModal_day"
                  :create-day="$formatDate(calendarDateSelect[0]) || true"
                  :function-update="onUpdateData"
                />
              </div>
            </div>
          </div>
          <div class="employee__right">
            <div class="employee__header">
              <h2 class="employee__header__title f24">
                {{
                  localStorage.translations.pages.statistic_employee.text[
                    'kontrol-rabochego-vremeni'
                  ]
                }}
              </h2>
              <div class="right f14">
                <div class="right__item">
                  <svg
                    width="18"
                    height="20"
                    viewBox="0 0 18 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 2H15V0H13V2H5V0H3V2H2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2ZM16 18H2V8H16V18ZM16 6H2V4H16V6Z"
                      fill="#BEDBEB"
                    />
                  </svg>
                  <p>
                    <span>{{
                      formatDate(this.$route.query.start) +
                      (this.$route.query.start !== this.$route.query.end
                        ? ' - ' + formatDate(this.$route.query.end)
                        : '')
                    }}</span>
                  </p>
                </div>
              </div>
            </div>
            <template v-if="sortReportsByDay">
              <div class="employee__tables" v-if="sortingPeriodsWorkByProjects.length">
                <BaseAccordion
                  v-for="(project, index) in sortingPeriodsWorkByProjects"
                  :key="index"
                  :text="project.project.name"
                  :extra="project.project.is_extra == 1"
                  type="project"
                  :show="{name: 'ProjectsProjectShow', params: {id: project.project.id}}"
                >
                  <TimeControlShowEmployeeTableCurentDate :periods="project.reports" />
                  <div class="employee__tables__extra">
                    <TimeControlShowEmployeeTableCurentDate
                      v-if="project.extras.length"
                      :periods="project.extras"
                      extra
                    />
                  </div>
                </BaseAccordion>
              </div>
              <TimeControlShowEmployeeTableAllTime
                :time_work="workingTime(allWorkTime())"
                :time_extra="$formatTime(extraWorkTimeAll())"
                class="mb-10"
              />
              <div class="employee__days">
                <template v-for="(day, index) in sortReportsByDay">
                  <TimeControlShowEmployeeDay
                    :key="index"
                    :day="day"
                    :date="index"
                    :periods="employeeReports.periods"
                    :function-update="onUpdateData"
                  />
                </template>
              </div>
            </template>
            <Plug v-else />
          </div>
        </div>
        <LoadingAnimation v-if="loadingPage" key="loading" />
      </div>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import TemplateView from 'components/templates/TemplateView'
import TimeControlShowEmployeeTableCurentDate from 'components/timeControl/showEmployee/TimeControlShowEmployeeTableCurentDate'
import TimeControlShowEmployeeDay from 'components/timeControl/showEmployee/day/TimeControlShowEmployeeDay'
import TimeControlShowEmployeeTableAllTime from 'components/timeControl/showEmployee/TimeControlShowEmployeeTableAllTime'
import StatisticEmployeeReportModal from 'components/timeControl/showEmployee/StatisticEmployeeReportModal'

import EmployeesPhoto from 'components/employees/EmployeesPhoto'
import LoadingAnimation from 'components/LoadingAnimation'
import Plug from 'components/Plug'

export default {
  name: 'timeControlShowEmployee',
  refs: ['datePicker'],
  components: {
    TimeControlShowEmployeeTableCurentDate,
    TimeControlShowEmployeeDay,
    EmployeesPhoto,
    LoadingAnimation,
    Plug,
    TimeControlShowEmployeeTableAllTime,
    TemplateView,
    StatisticEmployeeReportModal,
  },
  data() {
    return {
      calendarDateSelect: [],
      arrayEvents: null,
      calendarLoading: false,
      firstRun: true,
      datePickerFirsLoad: true,
      loadingPage: true,
    }
  },
  async created() {
    await this.onPushQuery({
      start: this.$route.query.start,
      end: this.$route.query.end,
      mounth: this.$route.query.mounth,
      year: this.$route.query.year,
      firstLoad: true,
    })
    this.onDownloadPageData({ updateCalendar: true })
  },
  computed: {
    ...mapGetters('employee', ['employeeReports', 'employeeReportsDays']),
    datePicker() {
      return this.$refs.datePicker
    },
    tableMounth() {
      return this.$refs.datePicker && this.$refs.datePicker.tableMonth
    },
    tableYear() {
      return this.$refs.datePicker && this.$refs.datePicker.tableYear
    },
    activeDays() {
      return !this.calendarLoading
        ? this.employeeReportsDays.map((i) => {
            const [, , day] = i.split('-')
            return parseInt(day, 10)
          })
        : []
    },
    currentDay() {
      return new Date().getDate()
    },
    currentMounth() {
      return new Date().getMonth()
    },
    currentYear() {
      return new Date().getFullYear()
    },
    sortingPeriodsWorkByProjects() {
      let reports = this.employeeReports.reports
      let result = []
      for (let object of reports) {
        for (let report of object.reports) {
          const checkProject = (obj) =>
            obj.project.id === report.project.id && obj.project.is_extra === report.project.is_extra
          if (
            (report.work_type.is_hourly === 0 && report.size) ||
            (report.work_type.is_hourly === 1 && report.hours)
          ) {
            const findProject = result[result.findIndex(checkProject)]
            let itemObj = {}
            itemObj.work_type = report.work_type
            itemObj.size = report.size
            itemObj.hours = report.hours
            if (!findProject) {
              result.push({
                project: report.project,
                reports: [itemObj],
                extras: [],
              })
            } else {
              const checkWorkType = (obj) => obj.work_type.id === report.work_type.id
              let findReport = findProject.reports[findProject.reports.findIndex(checkWorkType)]
              if (!findReport) {
                findProject.reports.push(itemObj)
              } else {
                findReport.size += report.size
                findReport.hours += report.hours
              }
            }
          }
        }
        for (let extra of object.extras) {
          const checkProject = (obj) =>
            obj.project.id === extra.project.id && obj.project.is_extra === extra.project.is_extra
          const findProject = result[result.findIndex(checkProject)]
          let itemObj = {}
          itemObj.work_extra_type = extra.work_extra_type
          itemObj.size = extra.size
          itemObj.hours = extra.hours
          if (!findProject) {
            result.push({
              project: extra.project,
              reports: [],
              extras: [itemObj],
            })
          } else {
            const checkWorkExtraType = (obj) => obj.work_extra_type.id === extra.work_extra_type.id
            let findExtra = findProject.extras[findProject.extras.findIndex(checkWorkExtraType)]
            if (!findExtra) {
              findProject.extras.push(itemObj)
            } else {
              findExtra.size += extra.size
              findExtra.hours += extra.hours
            }
          }
        }
      }
      return result
    },
    sortingPeriodsByProjects() {
      let result = []
      if (this.employeeReports.periods !== null) {
        for (let period of this.employeeReports.periods) {
          const checkProject = (obj) =>
            obj.project_id === period.project_id && obj.is_extra === period.is_extra
          if (result.findIndex(checkProject) === -1) {
            result.push({
              project_id: period.project_id,
              project: period.project,
              is_extra: period.is_extra,
              periods: [period],
            })
          } else {
            result[result.findIndex(checkProject)].periods.push(period)
          }
        }
      }
      return result
    },
    checkSelectedDate() {
      return this.calendarDateSelect.every((val) => this.employeeReportsDays.includes(val))
    },
    checkingAvailableDate() {
      let dates = []
      if (
        this.$userCheckAccess({
          abilities: 'edit_work_days',
        }) &&
        this.employeeReports.periods !== null
      ) {
        for (let period of this.employeeReports.periods) {
          dates = Array.from(
            new Set(dates.concat(this.$getDates(period.start_date, period.end_date, true))),
          )
        }
      }
      if (this.employeeReportsDays !== null) {
        dates = Array.from(new Set(dates.concat(this.employeeReportsDays)))
      }
      return dates
    },
    sortReportsByDay() {
      let reports = this.employeeReports.reports
      let data = null
      if (reports && reports.length) {
        data = {}
        for (let report of reports) {
          report.data = JSON.parse(report.data)
          const [day, time] = report.start.split(' ')
          if (!data[this.$formatDate(day)]) {
            data[this.$formatDate(day)] = []
          }
          data[this.$formatDate(day)].push(report)
        }
      }
      if (data !== null && Object.keys(data).length) {
        data = Object.keys(data)
          .sort(function (a, b) {
            return a < b ? 1 : -1
          })
          .reduce(function (result, key) {
            result[key] = data[key]
            return result
          }, {})
      }
      return data
    },
  },

  watch: {
    tableMounth(newVal, oldVal) {
      if (oldVal !== undefined && this.tableMounth !== this.$route.query.mounth) {
        this.onPushQuery({ mounth: this.tableMounth, year: this.tableYear })
        this.calendarDateSelect = []
      }
    },
    calendarDateSelect() {
      if (!this.checkSelectedDate) {
        if (this.calendarDateSelect[1]) {
          this.calendarDateSelect = [this.calendarDateSelect[1]]
        }
      }
      if (this.calendarDateSelect[0] > this.calendarDateSelect[1]) {
        let start = this.calendarDateSelect[0]
        let end = this.calendarDateSelect[1]
        this.calendarDateSelect[0] = end
        this.calendarDateSelect[1] = start
      }
    },
    '$route.query'(newVal, oldVal) {
      this.onDownloadPageData({
        updateCalendar: newVal.year !== oldVal.year ? true : newVal.mounth !== oldVal.mounth,
      })
    },
  },
  mounted() {
    this.arrayEvents = [...Array(6)].map(() => {
      const day = Math.floor(Math.random() * 30)
      const d = new Date()
      d.setDate(day)
      return d.toISOString().substr(0, 10)
    })
  },
  methods: {
    ...mapActions('workClientProject', ['onWorkClientProjectStatistic']),
    ...mapActions('employee', ['onEmployeeReportsDays', 'onEmployeeReports']),
    ...mapMutations('workClientProject', ['setWorkClientProjectStatistic']),
    ...mapMutations('employee', ['setEmployeeReports', 'setEmployeeReportsDays']),
    ...mapActions('commonUser', ['onCommonUserData']),
    onPushQuery({ start, end, mounth, year, firstLoad }) {
      let query = Object.assign({}, this.$route.query)
      const useMounth =
        mounth >= 0 ? mounth : this.tableMounth >= 0 ? this.tableMounth : this.currentMounth
      const useYear = year || this.tableYear || this.currentYear
      const dateNow = new Date()
      const firstDay = new Date(useYear, useMounth, 2).toISOString().slice(0, 10)
      const lastDay = year
        ? new Date(year, useMounth + 1, 1).toISOString().slice(0, 10)
        : dateNow.toISOString().slice(0, 10)
      if (start && end) {
        query.start = start
        query.end = end
      } else {
        query.start = firstDay
        query.end = lastDay
      }
      query.mounth = useMounth
      query.year = useYear
      this.$router[firstLoad ? 'replace' : 'push']({ query }).catch(() => {})
    },
    async onDownloadPageData({ updateCalendar }) {
      if (this.$route.query.year && this.$route.query.mounth) {
        this.loadingPage = true
        if (this.firstRun) {
          if (this.$route.name === 'employeeStatistic') {
            this.onCommonUserData(this.$route.params.userId)
          } else {
            this.onWorkClientProjectStatistic(this.$route.params.id)
          }
        }
        let params = {
          employee_id: this.$route.params.employeeId,
          start: this.$route.query.start,
          end: this.$route.query.end,
        }
        if (updateCalendar) {
          this.getCalendar()
        }
        await this.onEmployeeReports(params)
          .then(() => {
            if (this.firstRun) {
              this.firstRun = false
            }
          })
          .catch((error) => {
            if (error.response.status == 404) {
              this.$router.go(-1)
            }
          })
        this.loadingPage = false
      }
    },
    onUpdateData({ day, calendar }) {
      if (calendar) {
        if (
          this.calendarDateSelect.length === 0 ||
          (this.$route.query.start === this.calendarDateSelect[0] &&
            (this.calendarDateSelect[1]
              ? this.calendarDateSelect[1] === this.$route.query.end
              : this.calendarDateSelect[0] === this.$route.query.end))
        ) {
          this.onDownloadPageData({ updateCalendar: false })
        } else {
          this.onPushQuery({
            start: this.calendarDateSelect[0] || this.$route.query.start,
            end: this.calendarDateSelect[1]
              ? this.calendarDateSelect[1]
              : this.calendarDateSelect[0] || this.$route.query.end,
          })
        }
      }
      if (day) {
        if (this.employeeReportsDays.indexOf(day) === -1) {
          let data = this.employeeReportsDays
          data.push(day)
          this.setEmployeeReportsDays(data)
        }
      }
    },
    async getCalendar() {
      console.warn('getCalendar', { year: this.$route.query.year, month: this.$route.query.mounth })
      const firstDay = new Date(Number(this.$route.query.year), Number(this.$route.query.mounth), 2)
        .toISOString()
        .slice(0, 10)
      const lastDay = new Date(
        Number(this.$route.query.year),
        Number(this.$route.query.mounth) + 1,
        1,
      )
        .toISOString()
        .slice(0, 10)
      const params = {
        employee_id: this.$route.params.employeeId,
        start: firstDay,
        end: lastDay,
      }
      await this.onEmployeeReportsDays(params)
    },
    allowedDates(val) {
      return this.checkingAvailableDate.find((i) => i === val)
    },
    onFilterByProject(projectId) {
      if (this.workClientProjectProgress) {
        return this.workClientProjectProgress.filter((i) => i.id === projectId)
      }
    },
    checkPeriodsShow(array) {
      return (
        array &&
        array.filter((i) =>
          this.firstRun
            ? i.done_employee > 0
            : this.$route.query.start && this.$route.query.end
            ? i.done_employee > 0 &&
              ((this.$route.query.start >= i.start_date && this.$route.query.start <= i.end_date) ||
                (this.$route.query.end >= i.start_date && this.$route.query.end <= i.end_date))
            : i.done_employee > 0,
        )
      )
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    formatStartEndDate(dateInput) {
      let date = new Date(dateInput)
      let formattedDate =
        (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) +
        '.' +
        (date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
        '.' +
        date.getFullYear()
      return formattedDate
    },

    onAllowedDates(val) {
      for (var i = 0; i < this.employeeReportsDays.length; i++) {
        if (this.employeeReportsDays[i] == val) {
          return val
        }
      }
    },
    functionEvents(date) {
      const [, , day] = date.split('-')
      if (this.currentYear == this.tableYear && this.currentMounth == this.tableMounth) {
        if (this.activeDays.includes(parseInt(day, 10))) return '#D5FADE'
        else if (day < this.currentDay) return '#F68787'
      } else {
        if (this.activeDays.includes(parseInt(day, 10))) return '#D5FADE'
        else return '#F68787'
      }
      return false
    },
    extraWorkTimeAll() {
      let allObjectWithExtra = this.employeeReports.reports.filter((i) => i.extras.length)
      let result = 0
      for (var object = 0; object < allObjectWithExtra.length; object++) {
        for (var i = 0; i < allObjectWithExtra[object].extras.length; i++) {
          result += allObjectWithExtra[object].extras[i].hours
        }
      }
      return result
    },
    allWorkTime() {
      let allObjectWithTime = this.employeeReports.reports.filter((i) => i.end && i.start)
      let result = 0
      for (var key = 0; key < allObjectWithTime.length; key++) {
        let different =
          new Date(allObjectWithTime[key].end) - new Date(allObjectWithTime[key].start)
        result += different
      }
      return result
    },
    workingTime(different) {
      if (different) {
        let hours, minuts, seconds
        if (different > 0) {
          // hours = Math.floor(different / 3600000)
          // minuts = Math.round((different % 3600000) / 60000)
          // seconds = Math.round(((different % 3600000) % 60000) / 1000)
          // hours = Math.floor(different / 1000 / 60 / 60)
          // minuts = Math.floor((different / 1000 / 60 / 60 - hours) * 60)
          // seconds = Math.floor(((different / 1000 / 60 / 60 - hours) * 60 - minuts) * 60)
          hours = Math.floor(different / 1000 / 60 / 60)
          different -= hours * 1000 * 60 * 60
          minuts = Math.floor(different / 1000 / 60)
          different -= minuts * 1000 * 60
          seconds = Math.floor(different / 1000)
          different -= seconds * 1000
        }
        let result =
          (hours < 10 ? '0' + hours : hours) +
          ':' +
          (minuts < 10 ? '0' + minuts : minuts) +
          ':' +
          (seconds < 10 ? '0' + seconds : seconds)
        return result
      } else {
        return '00:00:00'
      }
    },
  },
  destroyed() {
    this.setWorkClientProjectStatistic()
    this.setEmployeeReports()
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  .employee {
    display: grid;
    grid-template-columns: 1fr 3fr;
    column-gap: 24px;

    @media #{map-get($display-breakpoints, 'md-and-down')} {
      grid-template-columns: 1fr;
      grid-template-rows: auto;
    }

    &__left {
      height: max-content;
      display: grid;
      row-gap: 10px;
      @media #{map-get($display-breakpoints, 'md-and-down')} {
        max-width: 400px;
        justify-self: center;
      }
      //@media #{map-get($display-breakpoints, 'sm-only')} {
      //    grid-template-columns: 1fr auto;
      //}
      //@media #{map-get($display-breakpoints, 'xs-only')} {
      //    grid-template-columns: auto;
      //}
    }
    &__right {
      display: grid;
      height: max-content;
      // row-gap: 60px;
    }
    &__avatar {
      background: #ffffff;
      border: 1px solid #ebeff2;
      box-sizing: border-box;
      padding: 10px 44px;
      //@media #{map-get($display-breakpoints, 'md-and-down')} {
      //    background-color: transparent;
      //    border: none;
      //}
      @media #{map-get($display-breakpoints, 'md-and-down')} {
        padding: 10px;
      }
      &__header {
        display: grid;
        grid-template-columns: max-content auto;
        align-items: center;
        column-gap: 16px;
        @media #{map-get($display-breakpoints, 'sm-and-down')} {
          grid-template-columns: auto;
          justify-content: center;
          justify-items: center;
        }
      }
      // &__text {
      //     margin-top: 20px;
      //     display: grid;
      //     justify-content: center;
      // }
    }
    &__calendar {
      background: #ffffff;
      border: 1px solid #ebeff2;
      box-sizing: border-box;
      display: grid;
      &__text {
        padding: 16px 30px;
        border-bottom: 1px solid #ebeff2;
        text-align: center;
      }
      &__box {
        padding: 30px;
        display: grid;
        row-gap: 30px;
        justify-content: center;
        justify-items: center;
        position: relative;
        @media #{map-get($display-breakpoints, 'xs-only')} {
          padding: 30px 0;
          margin: 0 -10px;
        }
        :deep() .box__modal {
          position: absolute;
          right: 15px;
          top: 50%;
        }
      }
    }
    &__header {
      display: grid;
      grid-template-columns: max-content max-content;
      justify-content: space-between;
      padding-bottom: 8px;
      align-items: center;
      margin-bottom: 16px;

      @media #{map-get($display-breakpoints, 'md-and-down')} {
        grid-template-columns: 1fr !important;
        padding-top: 20px;
        grid-gap: 20px;
      }
      .right {
        display: flex;
        column-gap: 30px;
        &__item {
          background: #277faf;
          border-radius: 10px;
          padding: 10px 15px;
          display: flex;
          align-items: center;
          color: #858b8e;
          svg {
            margin-right: 10px;
          }
          p {
            margin: 0;
            color: #ffffff;
          }
        }
      }
    }
    &__tables {
      display: grid;
      row-gap: 15px;
      margin-bottom: 20px;
      &__extra {
        margin-left: 25px;
      }
    }
    &__days {
      display: grid;
      row-gap: 60px;
    }
    &__period {
      display: grid;
      gap: 30px;
      margin-bottom: 60px;
      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        grid-template-columns: 1fr;
      }
    }
  }
  :deep().v-date-picker {
    &-header__value button {
      &:first-letter {
        text-transform: uppercase;
      }
    }
    &-table {
      height: auto;
      &--date {
        table {
          border-collapse: collapse;
          thead {
            th {
              color: #2c2c2c;
            }
          }
          tbody {
            td,
            th {
              padding: 3px; /* Поля вокруг содержимого таблицы */
              border: 1px solid #ebeff2; /* Параметры рамки */
            }
            td {
              padding: 0;
            }
          }
        }

        .v-btn {
          width: 40px;
          height: 40px;
          &--rounded {
            border-radius: 0px;
          }
        }
      }
    }
  }
 .temp {
  :deep() .v-input__slot{
  width: max-content !important;
  }
}
}
</style>
